module.exports = __webpack_public_path__ + "img/vcr_icon.037c2395.svg";